module.exports = __webpack_public_path__ + "img/product1.176c803c.png";